<script>
export default {
  methods: {
    getAxisMax (originalMax) {
      // Multiply by 10 to ensure that we're always working with a number of 2 digits
      var max = originalMax * 10

      // Convert to string
      var maxString = parseInt(max).toString()

      // Compute the final added value
      var maxAddString = '1'
      for (var i = 0; i < maxString.length - 2; i++) {
        maxAddString += '0'
      }

      // Build the final number by adding the proper number of 0 from the original number
      var maxIndex = maxString.substring(0, 2)
      for (i = 0; i < maxString.length - 2; i++) {
        maxIndex += '0'
      }

      // Add the new value
      max = parseInt(maxIndex) + parseInt(maxAddString)

      if (max.toString().length - 1 > maxAddString.length) {
        maxAddString += '0'
      }

      while ((originalMax * 10 / max) > 0.98) {
        max += parseInt(maxAddString)
      }

      // Divide by 10
      max = max / 10

      // Compute step
      var step = max / 10

      return {
        max: max,
        step: step
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/ChartValuesMixin.vue